export default [
  ['aardvark', 'aardvarks'],
  ['aborigine', 'aborigines'],
  ['accessory', 'accessories'],
  ['accident', 'accidents'],
  ['accomplice', 'accomplices'],
  ['accomplishment', 'accomplishments'],
  ['accountant', 'accountants'],
  ['actor', 'actors'],
  ['actress', 'actresses'],
  ['addressee', 'addressees'],
  ['aficionado', 'aficionados'],
  ['agency', 'agencies'],
  ['agent', 'agents'],
  ['aide', 'aides'],
  ['ailment', 'ailments'],
  ['airplane', 'airplanes'],
  ['alchemist', 'alchemists'],
  ['alien', 'aliens'],
  ['alligator', 'alligator'],
  ['ambassador', 'ambassadors'],
  ['amphibian', 'amphibians'],
  ['anaconda', 'anacondas'],
  ['anchovy', 'anchovies'],
  ['angel', 'angels'],
  ['animal', 'animals'],
  ['answer', 'answers'],
  ['ant', 'ants'],
  ['anteater', 'anteaters'],
  ['antelope', 'antelopes'],
  ['antibiotic', 'antibiotics'],
  ['antibody', 'antibody'],
  ['apartment', 'apartments'],
  ['apple', 'apples'],
  ['apricot', 'apricots'],
  ['archer', 'archers'],
  ['ark', 'arks'],
  ['armadillo', 'armadillos'],
  ['aroma', 'aromas'],
  ['article', 'articles'],
  ['artisan', 'artisans'],
  ['artist', 'artists'],
  ['assassin', 'assassins'],
  ['asteroid', 'asteroids'],
  ['astronauts', 'astronauts'],
  ['athlete', 'athletes'],
  ['atom', 'atoms'],
  ['attourney', 'attourneys'],
  ['baby', 'babies'],
  ['bachelor', 'bachelors'],
  ['backbone', 'backbones'],
  ['badge', 'badges'],
  ['bag', 'bags'],
  ['bagpipe', 'bagpipes'],
  ['bailiff', 'bailiffs'],
  ['baker', 'bakers'],
  ['ball', 'balls'],
  ['ballerina', 'ballerinas'],
  ['banana', 'bananas'],
  ['bandit', 'bandits'],
  ['bank', 'bankers'],
  ['banker', 'banks'],
  ['banshee', 'banshees'],
  ['barbarian', 'barbarians'],
  ['barber', 'barbers'],
  ['bard', 'bards'],
  ['baron', 'barons'],
  ['baseball player', 'baseball players'],
  ['baseball', 'baseballs'],
  ['basilisk', 'basilisks'],
  ['basket', 'baskets'],
  ['basketball player', 'basketball players'],
  ['basketball', 'basketballs'],
  ['bastard', 'bastards'],
  ['bat', 'bats'],
  ['battalion', 'battalions'],
  ['battlement', 'battlements'],
  ['bear', 'bears'],
  ['beast', 'beasts'],
  ['beaver', 'beavers'],
  ['bed', 'beds'],
  ['bee', 'bees'],
  ['beggar', 'beggars'],
  ['bell', 'bells'],
  ['bellboy', 'bellboys'],
  ['berry', 'berries'],
  ['bicycle', 'bicycles'],
  ['bicyclist', 'bicyclists'],
  ['biologist', 'biologists'],
  ['bird', 'birds'],
  ['bishop', 'bishops'],
  ['blacksmith', 'blacksmiths'],
  ['boar', 'boars'],
  ['boat', 'boats'],
  ['body builder', 'body builders'],
  ['bodyguard', 'bodyguards'],
  ['boogeyman', 'boogeymen'],
  ['book', 'books'],
  ['boomerang', 'boomerangs'],
  ['booster', 'boosters'],
  ['boss', 'bosses'],
  ['bottle', 'bottles'],
  ['box', 'boxers'],
  ['boxer', 'boxes'],
  ['boy', 'boys'],
  ['bracelet', 'bracelets'],
  ['brawler', 'brawlers'],
  ['bride', 'brides'],
  ['bridge', 'bridges'],
  ['brother', 'brothers'],
  ['bucket', 'buckets'],
  ['buddy', 'buddies'],
  ['buffalo', 'buffaloes'],
  ['bug', 'buglers'],
  ['bugle', 'bugles'],
  ['bugler', 'bugs'],
  ['builder', 'builders'],
  ['bull', 'bullets'],
  ['bullet', 'bullies'],
  ['bully', 'bulls'],
  ['bundle', 'bundles'],
  ['burglar', 'burglars'],
  ['bus', 'buses'],
  ['bush', 'bushes'],
  ['businessman', 'businessmen'],
  ['bystander', 'bystanders'],
  ['cabbage', 'cabbages'],
  ['cable', 'cable'],
  ['cadaver', 'cadavers'],
  ['cadet', 'cadets'],
  ['cake', 'cakes'],
  ['calendar', 'calendars'],
  ['caliper', 'calipers'],
  ['camel', 'camels'],
  ['camera', 'cameramen'],
  ['cameraman', 'cameras'],
  ['camp', 'campers'],
  ['camper', 'camps'],
  ['candle', 'candies'],
  ['candy', 'candles'],
  ['cane', 'cane'],
  ['cannon', 'cannonballs'],
  ['cannonball', 'cannons'],
  ['canoe', 'canoes'],
  ['cantaloupe', 'cantaloupes'],
  ['canteen', 'canteens'],
  ['cape', 'capes'],
  ['captain', 'captains'],
  ['car', 'cards'],
  ['card', 'carpenters'],
  ['carpenter', 'carrots'],
  ['carrot', 'cars'],
  ['carton of milk', 'cartons of milk'],
  ['cartridge', 'cartridges'],
  ['castle', 'castles'],
  ['cat', 'cats'],
  ['celebrity', 'celebrities'],
  ['cell', 'cellists'],
  ['cellist', 'cellos'],
  ['cello', 'cells'],
  ['chair', 'chairmen'],
  ['chairman', 'chairs'],
  ['champion', 'champions'],
  ['chancellor', 'chancellors'],
  ['charriot', 'charrioteers'],
  ['charrioteer', 'charriots'],
  ['chart', 'charts'],
  ['checker', 'checkers'],
  ['checklist', 'checklists'],
  ['cheese', 'cheeses'],
  ['cheetah', 'cheetahs'],
  ['chef', 'chefs'],
  ['chemical', 'chemicals'],
  ['chemist', 'chemists'],
  ['chest', 'chests'],
  ['chick', 'chicks'],
  ['child', 'children'],
  ['chimera', 'chimeras'],
  ['chiropractor', 'chiropractors'],
  ['chisel', 'chisels'],
  ['chocolate', 'chocolates'],
  ['choir', 'choirs'],
  ['choreographer', 'choreographers'],
  ['cigar', 'cigarettes'],
  ['cigarette', 'cigars'],
  ['circle', 'circles'],
  ['circuit', 'circuits'],
  ['city', 'cities'],
  ['clairvoyant', 'clairvoyants'],
  ['clam', 'clams'],
  ['clan', 'clans'],
  ['clarinet', 'clarinets'],
  ['class', 'classes'],
  ['clergyman', 'clergymen'],
  ['cleric', 'clerics'],
  ['clerk', 'clerks'],
  ['clicker', 'clickers'],
  ['client', 'clients'],
  ['climber', 'climbers'],
  ['cloak', 'cloaks'],
  ['clock', 'clocks'],
  ['clown', 'clowns'],
  ['club', 'clubs'],
  ['coach', 'coaches'],
  ['coat', 'coats'],
  ['cockatiel', 'cockatiels'],
  ['cockatoo', 'cockatoos'],
  ['cocktail', 'cocktails'],
  ['coffin', 'coffins'],
  ['coin', 'coins'],
  ['college', 'colleges'],
  ['collie', 'collies'],
  ['colt', 'colts'],
  ['comb', 'combines'],
  ['combine', 'combs'],
  ['comedian', 'comedians'],
  ['comet', 'comets'],
  ['comma', 'commandos'],
  ['commando', 'commas'],
  ['comment', 'commentators'],
  ['commentator', 'comments'],
  ['communicator', 'communicators'],
  ['company', 'companies'],
  ['compiler', 'compilers'],
  ['composer', 'composers'],
  ['computer', 'computers'],
  ['cone', 'cones'],
  ['consultant', 'consultants'],
  ['consumer', 'consumers'],
  ['contact', 'contacts'],
  ['container', 'containers'],
  ['contract', 'contractors'],
  ['contractor', 'contracts'],
  ['controller', 'controllers'],
  ['convict', 'convict'],
  ['cookie', 'cookies'],
  ['cop', 'cops'],
  ['core', 'cores'],
  ['corgi', 'corgis'],
  ['cork', 'corks'],
  ['corkscrew', 'corkscrews'],
  ['coroner', 'coroners'],
  ['counselors', 'counselors'],
  ['counter', 'counters'],
  ['country', 'countries'],
  ['couple', 'couples'],
  ['cow', 'cowards'],
  ['coward', 'cowboys'],
  ['cowboy', 'cows'],
  ['coyote', 'coyotes'],
  ['crab', 'crabs'],
  ['crate', 'crates'],
  ['creature', 'creatures'],
  ['creep', 'creeps'],
  ['crepe', 'crepes'],
  ['crescent', 'crescents'],
  ['criminal', 'criminals'],
  ['crowd', 'crowds'],
  ['crown', 'crowns'],
  ['crucifix', 'crucifixes'],
  ['crusader', 'crusaders'],
  ['crusher', 'crushers'],
  ['crystal', 'crystals'],
  ['cultist', 'cultists'],
  ['cup', 'cups'],
  ['curse', 'curses'],
  ['cushion', 'cushions'],
  ['cutthroat', 'cutthroats'],
  ['cyclist', 'cyclists'],
  ['cylinder', 'cylinders'],
  ['dagger', 'daggers'],
  ['dancer', 'dancers'],
  ['dandelion', 'dandelions'],
  ['deacon', 'deacons'],
  ['dealer', 'dealers'],
  ['debaters', 'debaters'],
  ['decimal', 'decimals'],
  ['decoration', 'decorations'],
  ['deer', 'deer'],
  ['deity', 'deities'],
  ['demon', 'demons'],
  ['dentist', 'dentists'],
  ['designer', 'designers'],
  ['desk', 'desks'],
  ['despot', 'despots'],
  ['dessert', 'desserts'],
  ['destroyer', 'destroyers'],
  ['developer', 'developers'],
  ['devil', 'devils'],
  ['diamond', 'diamonds'],
  ['diary', 'diaries'],
  ['dictator', 'dice'],
  ['die', 'dictator'],
  ['digit', 'digits'],
  ['dime', 'dimes'],
  ['dinghy', 'dinghys'],
  ['dingo', 'dingoes'],
  ['dinosaur', 'dinosaurs'],
  ['director', 'directors'],
  ['disc', 'disciples'],
  ['disciple', 'discs'],
  ['disk', 'disks'],
  ['dissenter', 'dissenters'],
  ['diver', 'divers'],
  ['doctor', 'doctors'],
  ['dog', 'dogs'],
  ['doll', 'dollars'],
  ['dollar', 'dolls'],
  ['dolphin', 'dolphins'],
  ['dome', 'domes'],
  ['donkey', 'donkeys'],
  ['door', 'doors'],
  ['dot', 'dots'],
  ['doubt', 'doubts'],
  ['dove', 'doves'],
  ['dragon', 'dragons'],
  ['dream', 'dreams'],
  ['dress', 'dresses'],
  ['drifter', 'drifters'],
  ['drink', 'drinks'],
  ['driver', 'drivers'],
  ['drone', 'drones'],
  ['drum', 'drums'],
  ['drunk', 'drunks'],
  ['duck', 'ducks'],
  ['dwarf', 'dwarves'],
  ['eagle', 'eagles'],
  ['ear', 'ears'],
  ['earthquake', 'earthquakes'],
  ['echo', 'echoes'],
  ['eclipse', 'eclipses'],
  ['editor', 'editors'],
  ['eel', 'eels'],
  ['egg', 'eggs'],
  ['elder', 'elders'],
  ['electron', 'electrons'],
  ['element', 'elements'],
  ['elephant', 'elephants'],
  ['elf', 'elves'],
  ['elitist', 'elitists'],
  ['elk', 'elk'],
  ['ellipsoid', 'ellipsoids'],
  ['emerald', 'emeralds'],
  ['emotion', 'emotions'],
  ['emperor penguin', 'emperor penguins'],
  ['emperor', 'emperors'],
  ['engineer', 'engineers'],
  ['eraser', 'erasers'],
  ['error', 'errors'],
  ['executioner', 'executioners'],
  ['explorer', 'explorers'],
  ['explosion', 'explosions'],
  ['extrovert', 'extroverts'],
  ['eye', 'eyes'],
  ['eyeball', 'eyeballs'],
  ['eyebrow', 'eyebrows'],
  ['eyelid', 'eyelids'],
  ['face', 'faces'],
  ['factory', 'factories'],
  ['failure', 'failures'],
  ['faker', 'fakers'],
  ['falcon', 'falcons'],
  ['fallacy', 'fallacies'],
  ['farmer', 'farmers'],
  ['feather', 'feathers'],
  ['fedora', 'fedoras'],
  ['feel', 'feels'],
  ['felon', 'felons'],
  ['fencer', 'fencers'],
  ['field', 'fields'],
  ['fighter', 'fighters'],
  ['film', 'films'],
  ['finger', 'fingers'],
  ['fireman', 'firemen'],
  ['fish', 'fish'],
  ['fisherman', 'fishermen'],
  ['flail', 'flails'],
  ['flame', 'flames'],
  ['flavor', 'flavors'],
  ['floater', 'floaters'],
  ['florist', 'florists'],
  ['flute', 'flutes'],
  ['flutist', 'flutists'],
  ['fly', 'flies'],
  ['foal', 'foals'],
  ['folder', 'folders'],
  ['foot', 'feet'],
  ['football', 'footballs'],
  ['forklift', 'forklifts'],
  ['fox', 'fox'],
  ['fraction', 'fractions'],
  ['fragment', 'fragments'],
  ['freighter', 'freighter'],
  ['friend', 'friends'],
  ['frog', 'frogs'],
  ['fuse', 'fuses'],
  ['gadget', 'gadgets'],
  ['gag', 'gags'],
  ['game', 'games'],
  ['gang', 'gangs'],
  ['gangster', 'gangsters'],
  ['gardener', 'gardeners'],
  ['gardenia', 'gardenias'],
  ['garlic clove', 'garlic cloves'],
  ['garment', 'garments'],
  ['garnet', 'garnets'],
  ['gate', 'gates'],
  ['gatling gun', 'gatling guns'],
  ['gauntlet', 'gauntlets'],
  ['gazelle', 'gazelles'],
  ['gem', 'gems'],
  ['generator', 'generators'],
  ['genie', 'genies'],
  ['gentleman', 'gentlemen'],
  ['geranium', 'geraniums'],
  ['germ', 'germs'],
  ['ghost', 'ghosts'],
  ['ghoul', 'ghouls'],
  ['giant', 'giants'],
  ['giblet', 'giblets'],
  ['ginger root', 'ginger roots'],
  ['girdle', 'girdles'],
  ['gladiator', 'gladiators'],
  ['glider', 'gliders'],
  ['gnome', 'gnomes'],
  ['goat', 'goats'],
  ['goblin', 'goblins'],
  ['god', 'gods'],
  ['gold bar', 'gold bars'],
  ['goldfish', 'goldfish'],
  ['golf ball', 'golf balls'],
  ['golfer', 'golfers'],
  ['goose', 'geese'],
  ['gorilla', 'gorillas'],
  ['governor', 'governors'],
  ['grain of rice', 'rice'],
  ['grape', 'grapes'],
  ['grapefruit', 'grapefruits'],
  ['graph', 'graphs'],
  ['grave', 'graves'],
  ['green bean', 'green beans'],
  ['grinch', 'grinches'],
  ['grizzly bear', 'grizzly bears'],
  ['guardian', 'guardians'],
  ['guest', 'guests'],
  ['guide', 'guides'],
  ['guitar', 'guitars'],
  ['guitarist', 'guitarists'],
  ['gull', 'gulls'],
  ['gun', 'guns'],
  ['gunfighter', 'gunfighters'],
  ['gunman', 'gunmen'],
  ['guru', 'gurus'],
  ['gymnast', 'gymnasts'],
  ['hacker', 'hackers'],
  ['hacksaw', 'hacksaws'],
  ['hailstone', 'hailstones'],
  ['halo', 'halos'],
  ['ham', 'hams'],
  ['hamburger', 'hamburgers'],
  ['hammer', 'hammers'],
  ['hamster', 'hamsters'],
  ['hand', 'hands'],
  ['handbag', 'handbags'],
  ['handgun', 'handguns'],
  ['handle', 'handles'],
  ['hare', 'hares'],
  ['harp', 'harps'],
  ['harpsichord', 'harpsichords'],
  ['harpsichordist', 'harpsichordists'],
  ['hat', 'hats'],
  ['hatchet', 'hatchets'],
  ['hatchling', 'hatchlings'],
  ['hawk', 'hawks'],
  ['haystack', 'haystacks'],
  ['hazelnut', 'hazelnuts'],
  ['head', 'heads'],
  ['headline', 'headlines'],
  ['healer', 'healers'],
  ['heart', 'hearts'],
  ['hedgehog', 'hedgehogs'],
  ['helecopter', 'helecopters'],
  ['helmet', 'helmets'],
  ['helper', 'helpers'],
  ['henchman', 'henchmen'],
  ['henchwoman', 'henchwomen'],
  ['herald', 'heralds'],
  ['hero', 'heroes'],
  ['heroine', 'heroines'],
  ['herring', 'herrings'],
  ['hex', 'hexes'],
  ['hexagon', 'hexagons'],
  ['hick', 'hicks'],
  ['highwayman', 'highwaymen'],
  ['hiker', 'hikers'],
  ['hill', 'hills'],
  ['hillbilly', 'hillbillies'],
  ['hint', 'hints'],
  ['hipster', 'hipsters'],
  ['hitchhiker', 'hitchhikers'],
  ['hobbit', 'hobbits'],
  ['hobo', 'hobos'],
  ['hockey puck', 'hockey pucks'],
  ['honeybee', 'honeybees'],
  ['honeysuckle flower', 'honeysuckle flowers'],
  ['hood', 'hoods'],
  ['hoodlum', 'hoodlums'],
  ['hook', 'hooks'],
  ['hookworm', 'hookworms'],
  ['hooligan', 'hooligans'],
  ['hormone', 'hormones'],
  ['horn', 'horns'],
  ['horse', 'horses'],
  ['horseman', 'horsemen'],
  ['horsewoman', 'horsewomen'],
  ['host', 'hosts'],
  ['hostage', 'hostages'],
  ['hound', 'hounds'],
  ['huckster', 'hucksters'],
  ['hunchback', 'hunchbacks'],
  ['hunter', 'hunters'],
  ['hurricane', 'hurricanes'],
  ['hustler', 'hustlers'],
  ['hyena', 'hyenas'],
  ['hymn', 'hymns'],
  ['ice cube', 'ice cubes'],
  ['idea', 'ideas'],
  ['idiot', 'idiots'],
  ['idol', 'idols'],
  ['iguana', 'iguanas'],
  ['image', 'images'],
  ['infant', 'infantrymen'],
  ['infantryman', 'infants'],
  ['ingredient', 'ingredients'],
  ['injury', 'injuries'],
  ['insect', 'insects'],
  ['inspector', 'inspectors'],
  ['insult', 'insults'],
  ['integer', 'integers'],
  ['intellectual', 'intellectuals'],
  ['interrogator', 'interrogators'],
  ['intestine', 'intestines'],
  ['intruder', 'intruders'],
  ['invader', 'invaders'],
  ['inventor', 'inventors'],
  ['investor', 'investors'],
  ['ion', 'ions'],
  ['iron bar', 'iron bars'],
  ['iron pot', 'iron pots'],
  ['iron rod', 'iron rods'],
  ['jacket', 'jackets'],
  ['jaguar', 'jaguars'],
  ['janitor', 'janitors'],
  ['jar of jam', 'jars of jam'],
  ['jar of jelly', 'jars of jelly'],
  ['jar', 'jars'],
  ['javelin', 'javelins'],
  ['jawbone', 'jawbones'],
  ['jet', 'jets'],
  ['jewel', 'jewels'],
  ['job', 'jobs'],
  ['jockey', 'jockeys'],
  ['joke', 'jokes'],
  ['journal', 'journals'],
  ['journeyman', 'journeymen'],
  ['jouster', 'jousters'],
  ['judge', 'judges'],
  ['juggler', 'jugglers'],
  ['juror', 'jurors'],
  ['kabob', 'kabobs'],
  ['kaiser', 'kaisers'],
  ['kale leaf', 'kale'],
  ['kaleidoscope', 'kaleidoscope'],
  ['kangaroo', 'kangaroos'],
  ['kazoo', 'kazoos'],
  ['keg', 'kegs'],
  ['key', 'keys'],
  ['khan', 'khans'],
  ['killer', 'killers'],
  ['king', 'kings'],
  ['kitchen', 'kitchens'],
  ['kitten', 'kittens'],
  ['kneecap', 'kneecaps'],
  ['knight', 'knights'],
  ['koala', 'koalas'],
  ['kung-fu fighter', 'kung-fu fighters'],
  ['ladder', 'ladders'],
  ['ladle', 'ladies'],
  ['lady', 'ladles'],
  ['lamb', 'lambs'],
  ['lamp', 'lamps'],
  ['lance', 'lances'],
  ['lantern', 'lanterns'],
  ['lark', 'larks'],
  ['larva', 'larvae'],
  ['lawyer', 'lawyers'],
  ['leaf', 'leaves'],
  ['liar', 'liars'],
  ['librarian', 'librarians'],
  ['lie', 'lice'],
  ['lighter', 'lies'],
  ['lime', 'lighters'],
  ['line', 'limes'],
  ['list', 'lines'],
  ['llama', 'lists'],
  ['lobster', 'llamas'],
  ['lock', 'lobsters'],
  ['locust', 'locks'],
  ['log', 'locust'],
  ['loon', 'logs'],
  ['lord', 'loons'],
  ['louse', 'lords'],
  ['lover', 'lovers'],
  ['lumberjack', 'lumberjacks'],
  ['lunar lander', 'lunar landers'],
  ['lung', 'lungs'],
  ['lure', 'lures'],
  ['machine gun', 'machine guns'],
  ['machine', 'machines'],
  ['mackerel', 'mackerels'],
  ['magazine', 'magazines'],
  ['magician', 'magicians'],
  ['magnet', 'magnets'],
  ['mailman', 'mailmen'],
  ['maniac', 'maniacs'],
  ['mannequin', 'manneguins'],
  ['marble', 'marbles'],
  ['marine', 'marines'],
  ['marker', 'markers'],
  ['marksman', 'marksmen'],
  ['mask', 'masks'],
  ['meal', 'meals'],
  ['medal', 'medals'],
  ['medium', 'mediums'],
  ['meeting', 'meetings'],
  ['melon', 'melons'],
  ['merchant', 'merchants'],
  ['mermaid', 'mermaids'],
  ['message', 'messages'],
  ['method', 'methods'],
  ['microbe', 'microbes'],
  ['microphone', 'microphones'],
  ['mink', 'minks'],
  ['mirror', 'mirrors'],
  ['missile', 'missiles'],
  ['model', 'models'],
  ['mole', 'moles'],
  ['monk', 'monks'],
  ['monkey', 'monkeys'],
  ['monster', 'monsters'],
  ['monument', 'monuments'],
  ['moon', 'moons'],
  ['mosquito', 'mosquitoes'],
  ['moth', 'moths'],
  ['motor', 'motors'],
  ['mouse', 'mice'],
  ['moustache', 'moustaches'],
  ['mouth', 'mouths'],
  ['murderer', 'murderers'],
  ['mushroom', 'mushrooms'],
  ['musket', 'muskets'],
  ['mystic', 'mystics'],
  ['narwal', 'narwals'],
  ['nebula', 'nebulas'],
  ['neck', 'necks'],
  ['necklace', 'necklaces'],
  ['necromancer', 'necromancers'],
  ['needle', 'needles'],
  ['net', 'nets'],
  ['neuromancer', 'neuromancers'],
  ['newspaper', 'newspapers'],
  ['newt', 'newts'],
  ['nightingale', 'nightingales'],
  ['nightmare', 'nightmares'],
  ['ninja', 'ninjas'],
  ['nobleman', 'noblemen'],
  ['novel', 'novelists'],
  ['novelist', 'novels'],
  ['number', 'numbers'],
  ['nun', 'nuns'],
  ['nurse', 'nurses'],
  ['nut', 'nuts'],
  ['nutshell', 'nutshells'],
  ['nymph', 'nymphs'],
  ['obelisk', 'obelisks'],
  ['ocarina', 'ocarinas'],
  ['ocelot', 'ocelots'],
  ['octopus', 'octopuses'],
  ['odor', 'odors'],
  ['officer', 'officers'],
  ['olive', 'olives'],
  ['omelet', 'omelets'],
  ['omen', 'omens'],
  ['omen', 'onions'],
  ['oracle', 'oracles'],
  ['orator', 'orators'],
  ['orphan', 'orphans'],
  ['otter', 'otters'],
  ['outcast', 'outcasts'],
  ['outlaw', 'outlaws'],
  ['outsider', 'outsiders'],
  ['oval', 'ovals'],
  ['oven', 'ovens'],
  ['overseer', 'overseers'],
  ['owl', 'owls'],
  ['oyster', 'oysters'],
  ['pacifier', 'pacifiers'],
  ['padlock', 'padlocks'],
  ['page', 'pages'],
  ['paintbrush', 'paintbrushes'],
  ['painting', 'paintings'],
  ['pansy', 'pansies'],
  ['paper', 'papers'],
  ['parasite', 'parasites'],
  ['peach', 'peaches'],
  ['peacock', 'peacocks'],
  ['peanut', 'peanuts'],
  ['pear', 'pears'],
  ['pearl', 'pearls'],
  ['peasant', 'peasants'],
  ['pebble', 'pebbles'],
  ['pecan', 'pecans'],
  ['pen', 'pens'],
  ['pencil', 'pencils'],
  ['pendulum', 'pendulums'],
  ['penny', 'pennies'],
  ['pentagon', 'pentagons'],
  ['pepper', 'peppers'],
  ['phantom', 'phantoms'],
  ['pheasant', 'pheasants'],
  ['philosopher', 'philosophers'],
  ['phone', 'phones'],
  ['phonograph', 'phonographs'],
  ['photograph', 'photographs'],
  ['physicist', 'physicists'],
  ['pianist', 'pianists'],
  ['piano', 'pianos'],
  ['pickaxe', 'pickaxes'],
  ['pickle', 'pickles'],
  ['pie', 'pies'],
  ['piece of junk', 'junk'],
  ['pig', 'pigs'],
  ['pigeon', 'pigeons'],
  ['pill', 'pills'],
  ['pillow', 'pillows'],
  ['pineapple', 'pineapples'],
  ['pipe', 'pipes'],
  ['pirate', 'pirates'],
  ['pirhana', 'pirhana'],
  ['pistol', 'pistols'],
  ['pitchfork', 'pitchforks'],
  ['pizza', 'pizzas'],
  ['plane', 'planes'],
  ['plant', 'plantains'],
  ['plantain', 'plants'],
  ['plasma creature', 'plasma creatures'],
  ['plate', 'plates'],
  ['plunger', 'plungers'],
  ['poem', 'poems'],
  ['police officer', 'police officers'],
  ['politician', 'politicians'],
  ['polo player', 'polo players'],
  ['poodles', 'poodles'],
  ['pork chop', 'pork chops'],
  ['possum', 'possums'],
  ['potato', 'potatoes'],
  ['preacher', 'preachers'],
  ['predator', 'predators'],
  ['priest', 'priests'],
  ['prince', 'princes'],
  ['princess', 'princesses'],
  ['printer', 'printers'],
  ['prisoner', 'prisoners'],
  ['professor', 'professors'],
  ['programmer', 'programmers'],
  ['prophet', 'prophets'],
  ['proverb', 'proverbs'],
  ['psalm', 'psalms'],
  ['psychiatrist', 'psychiatrists'],
  ['pumpkin', 'pumpkins'],
  ['punk', 'punks'],
  ['puppet', 'puppets'],
  ['puppy', 'puppies'],
  ['puzzle', 'puzzles'],
  ['pyromaniac', 'pyromaniacs'],
  ['python', 'pythons'],
  ['quail', 'quails'],
  ['quart', 'quarters'],
  ['quartz stone', 'quartz stones'],
  ['queen', 'queens'],
  ['question', 'questions'],
  ['quiche', 'quiches'],
  ['quill', 'quills'],
  ['quilt', 'quilts'],
  ['quiver', 'quivers'],
  ['quote', 'quotes'],
  ['rabbi', 'rabbis'],
  ['rabbit', 'rabbits'],
  ['radiator', 'radiators'],
  ['radio', 'radios'],
  ['radish', 'radishes'],
  ['rag', 'rags'],
  ['raisin', 'raisins'],
  ['ram', 'rams'],
  ['ramp', 'ramps'],
  ['rancher', 'ranchers'],
  ['rapier', 'rapiers'],
  ['rapper', 'rappers'],
  ['rat', 'rats'],
  ['rattle', 'rattles'],
  ['razor', 'razors'],
  ['rebel', 'rebels'],
  ['recorder', 'recorders'],
  ['recruiter', 'recruiters'],
  ['refugee', 'refugees'],
  ['reporter', 'reporters'],
  ['rhyme', 'rhymes'],
  ['rib', 'ribs'],
  ['ribbon', 'ribbons'],
  ['rifle', 'rifles'],
  ['rifleman', 'riflemen'],
  ['ring', 'rings'],
  ['rival', 'rivals'],
  ['roach', 'roaches'],
  ['robber', 'robbers'],
  ['robe', 'robes'],
  ['robin', 'robins'],
  ['robot', 'robots'],
  ['rogue', 'rogues'],
  ['rooster', 'roosters'],
  ['roulette', 'roulettes'],
  ['ruler', 'rulers'],
  ['rumor', 'rumors'],
  ['runaway', 'runaway'],
  ['runner', 'runner'],
  ['runt', 'runt'],
  ['rutabaga', 'rutabagas'],
  ['saber', 'sabers'],
  ['sadist', 'sadists'],
  ['sage', 'sages'],
  ['sailor', 'sailors'],
  ['salad', 'salads'],
  ['salamander', 'salamanders'],
  ['salmon', 'salmon'],
  ['sandwich', 'sandwiches'],
  ['saxophone', 'saxophones'],
  ['scabbard', 'scabbards'],
  ['scapegoat', 'scapegoats'],
  ['scar', 'scars'],
  ['scarf', 'scarves'],
  ['scavenger', 'scavengers'],
  ['scholar', 'scholars'],
  ['scientist', 'scientists'],
  ['scimitar', 'scimitars'],
  ['scissors', 'scissors'],
  ['scout', 'scouts'],
  ['screw', 'screws'],
  ['scribe', 'scribes'],
  ['seahorse', 'seahorses'],
  ['seals', 'seals'],
  ['secret', 'secrets'],
  ['seed', 'seeds'],
  ['senator', 'senators'],
  ['sergeant', 'sergeants'],
  ['sesame seed', 'sesame seeds'],
  ['shadow', 'shadows'],
  ['sheep', 'sheep'],
  ['shepherd', 'shepherds'],
  ['sherrif', 'sheriffs'],
  ['shield', 'shields'],
  ['ship', 'ships'],
  ['shirt', 'shirts'],
  ['shoe', 'shoes'],
  ['shotgun', 'shotguns'],
  ['shovel', 'shovels'],
  ['shrimp', 'shrimp'],
  ['sidekick', 'sidekicks'],
  ['siren', 'sirens'],
  ['skeleton', 'skeletons'],
  ['skillet', 'skillets'],
  ['skirt', 'skirts'],
  ['skull', 'skull'],
  ['slob', 'slobs'],
  ['slogan', 'slogans'],
  ['slug', 'slugs'],
  ['smile', 'smiles'],
  ['snail', 'snails'],
  ['snake', 'snakes'],
  ['sniper', 'snipers'],
  ['snowball', 'snowballs'],
  ['snowman', 'snowmen'],
  ['sock', 'socks'],
  ['soldier', 'soldiers'],
  ['song', 'songs'],
  ['spaceship', 'spaceships'],
  ['speaker', 'speakers'],
  ['spectre', 'spectres'],
  ['spell', 'spells'],
  ['spider', 'spiders'],
  ['spirit', 'spirits'],
  ['spoon', 'spoons'],
  ['spring', 'springs'],
  ['spy', 'spies'],
  ['square', 'squares'],
  ['squid', 'squids'],
  ['squire', 'squires'],
  ['squirrel', 'squirrels'],
  ['stallion', 'stallions'],
  ['star', 'stars'],
  ['stone', 'stones'],
  ['stranger', 'strangers'],
  ['stream', 'streams'],
  ['student', 'students'],
  ['suitcase', 'suitcases'],
  ['surgeon', 'surgeons'],
  ['survivalist', 'survivalists'],
  ['survivor', 'survivors'],
  ['swallow', 'swallows'],
  ['swan', 'swans'],
  ['sweater', 'sweaters'],
  ['switchblade', 'switchblades'],
  ['sword', 'swords'],
  ['syringe', 'syringes'],
  ['table', 'tables'],
  ['tablet', 'tablets'],
  ['taco', 'tacos'],
  ['tail', 'tails'],
  ['task', 'tasks'],
  ['teacher', 'teachers'],
  ['teacup', 'teacups'],
  ['telephone', 'telephones'],
  ['tent', 'tents'],
  ['therapist', 'therapists'],
  ['thief', 'thieves'],
  ['thorn', 'thorns'],
  ['thug', 'thugs'],
  ['toad', 'toads'],
  ['tomato', 'tomatoes'],
  ['tooth', 'teeth'],
  ['torch', 'torches'],
  ['torpedo', 'torpedos'],
  ['tortoise', 'tortoises'],
  ['tourist', 'tourists'],
  ['toy', 'toys'],
  ['trader', 'traders'],
  ['traitor', 'traitors'],
  ['translator', 'translators'],
  ['trapezoid', 'trapezoids'],
  ['traveller', 'travellers'],
  ['treadmill', 'treadmills'],
  ['trooper', 'troopers'],
  ['trout', 'trouts'],
  ['trumpet', 'trumpets'],
  ['tuba', 'tubas'],
  ['tulip', 'tulips'],
  ['turkey', 'turkeys'],
  ['turret', 'turrets'],
  ['turtle', 'turtles'],
  ['typewriter', 'typewriters'],
  ['tyrant', 'tyrants'],
  ['umbrella', 'umbrellas'],
  ['umpire', 'umpires'],
  ['unicorn', 'unicorns'],
  ['unicycle', 'unicycles'],
  ['urn', 'urns'],
  ['usher', 'ushers'],
  ['vagabond', 'vagabonds'],
  ['vase', 'vases'],
  ['vegan', 'vegans'],
  ['vegetarian', 'vegetarians'],
  ['vigilante', 'vigilantes'],
  ['viking', 'vikings'],
  ['villager', 'villagers'],
  ['villain', 'villains'],
  ['violin', 'violins'],
  ['volleyball', 'volleyballs'],
  ['voodoo doll', 'voodoo dolls'],
  ['vulture', 'vultures'],
  ['wagon', 'wagons'],
  ['waiter', 'waiters'],
  ['walk', 'walks'],
  ['wall', 'wallets'],
  ['wallet', 'walls'],
  ['wand', 'wands'],
  ['wanderer', 'wanderers'],
  ['warlock', 'warlocks'],
  ['warlord', 'warlords'],
  ['warrior', 'warriors'],
  ['watch', 'watches'],
  ['watchdog', 'watchdogs'],
  ['watermelon', 'watermelons'],
  ['web', 'webs'],
  ['week', 'weeks'],
  ['whale', 'whales'],
  ['wheel', 'wheels'],
  ['whip', 'whips'],
  ['wildcat', 'wildcats'],
  ['window', 'windows'],
  ['wine bottle', 'wine bottles'],
  ['wing', 'wings'],
  ['wire', 'wires'],
  ['wisp', 'wisps'],
  ['witch', 'witches'],
  ['wizard', 'wizards'],
  ['wolf', 'wolves'],
  ['woodpecker', 'woodpeckers'],
  ['xylophone', 'xylophones'],
  ['yak', 'yaks'],
  ['yam', 'yams'],
  ['yeti', 'yetis'],
  ['yo-yo', 'yo-yos'],
  ['yoke', 'yokes'],
  ['zebra', 'zebras'],
  ['zipper', 'zippers'],
  ['zombie', 'zombies'],
  ['zuchini', 'zuchinis'],
];
